// Deprecated - use "useResponseErrors"
//
// v2 errors array to something usable in the views:
// [{ detail: "bar", pointer: "/data/attributes/foo", ...}, ...] => { foo: "bar" }
export const parseResponseErrors = (errors) => {
  try {
    return errors.reduce((mem, item) => {
      mem[item.source.pointer.replace("/data/attributes/", "")] = item.detail;
      return mem;
    }, {});
  } catch {
    return {};
  }
};
